import * as React from 'react';
import { DataTable } from '@/components/data-table/data-table';
import { useDataTable } from '@/hooks/use-data-table';
import { BlockRule } from '@/lib/api/blockRules';
import { MainTableState } from '@/lib/utils/table-state-utils';
import { DEFAULT_SKELETON_ROWS } from '@/config/data-table';
import { getBlockRulesTableColumns } from './block-rules-table-columns';
import { BlockRulesTableActionBar } from './block-rules-table-action-bar';
import { BlockRulesTableSkeleton } from './block-rules-table-skeleton';

interface BlockRulesTableProps {
    blockRules: BlockRule[];
    total: number;
    loading: boolean;
    onTableStateChange: (state: MainTableState) => void;
    onRefetch: () => void;
    onRowClick: (blockRule: BlockRule) => void;
    onDelete: (ids: string[]) => void;
    isDeleting?: boolean;
}

export function BlockRulesTable({
    blockRules,
    total,
    loading,
    onTableStateChange,
    onRefetch,
    onRowClick,
    onDelete,
    isDeleting,
}: BlockRulesTableProps) {
    const columns = React.useMemo(
        () => getBlockRulesTableColumns({ onDelete }),
        [onDelete],
    );

    const { table } = useDataTable({
        data: blockRules,
        columns,
        total,
        onTableStateChange,
        getRowId: (row: BlockRule) => row.id,
    });

    return (
        <DataTable
            table={table}
            actionBar={
                <BlockRulesTableActionBar
                    table={table}
                    onDeleteSelected={onDelete}
                    isDeleting={isDeleting}
                />
            }
            isLoading={loading}
            skeletonRows={<BlockRulesTableSkeleton rows={DEFAULT_SKELETON_ROWS} />}
            onRefresh={onRefetch}
            onRowClick={onRowClick}
        />
    );
}
